module.exports = __webpack_public_path__ + "img/team_leader_4.cbb36e5e.png";